var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnginecoolantLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    height: "50px",
    width: "50px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#010101;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{display:inline;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st5{display:inline;fill:#FFFFFF;}\r\n\t.st6{font-family:'MyriadPro-Bold';}\r\n\t.st7{font-size:15.3654px;}\r\n\t.st8{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st9{display:inline;fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st10{display:inline;fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3,11.8h28.2V7.6c0,0-0.1-0.4,0.6-0.5h8.1c0,0,0.7,0,0.8,0.9v3.9h4.5c0,0,1.1,0.2,1.2,1.3v27.1c0,0-0.1,1.3-1.5,1.3H2.6 c0,0-1.1,0.1-1.3-1.8V13.2C1.3,13.2,1.8,11.3,3.3,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3,13.4h28.9c0,0,1.2-0.2,1.2-1.6v-3h6.2V12c0,0,0.1,1.1,1.1,1.3h4.8v18.1c0,0-2.4-0.2-2.4-3.1 c0,0-0.7-1.1-1.5,0c0,0,0.1,3.2-2.7,3.2c0,0-2.8,0.3-2.9-3.2c0,0-0.7-1.1-1.5,0c0,0,0.3,3-2.8,3.2c0,0-2.2,0.2-2.7-2.1l-0.1-1 c0,0-0.8-1.2-1.5,0.1c0,0,0.1,2.9-3.1,2.9c0,0-2.3,0.1-2.7-3.2c0,0-0.7-0.8-1.4,0.1c0,0,0.3,3-2.9,3.2c0,0-2.6,0-2.7-3.1 c0,0-0.7-1.1-1.5,0c0,0,0,3.1-2.9,3.1c0,0-2.8,0-2.8-3.1c0,0-0.6-1.2-1.5,0c0,0-0.2,2.8-2.4,2.9V13.4H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3,33v7h42.2v-7c0,0-1.7,0.2-3.2-2c0,0-2.7,4.4-7.1,0c0,0-3.2,4.5-7.2,0c0,0-3,4.6-7.1,0.3 c0,0-3.1,4.3-7.2-0.3c0,0-3.1,4.9-7.3,0C6,31,6.1,32.7,3,33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnginecoolantLevel);
export default __webpack_public_path__ + "static/media/EnginecoolantLevel.0ccc326f0cb0ed023b1b1cdd5abe11f2.svg";
export { ForwardRef as ReactComponent };